<div class='gray-background' [ngClass]="{'popup-open': showResetApproval}" (click)="closeModal()"></div>
<div class='create-reset-password-modal-wrapper'>
  <div class='main-title'>{{ 'LOGIN.RESET_PASSWORD' | translate }}</div>
  <div class='data-wrapper'>
    <div class="img-wrapper">
      <img class='success-img' src="assets/images/login/success icon.png" alt="" /> 
  </div>
    <div class="email-title">{{message}}</div>
  </div>
</div>